import { z } from 'zod';

// The author's country and department, remembered across ideas so they don't pick them every time.
const STORAGE_KEY = 'cult:idea-workplace';

const IdeaWorkplaceSchema = z.object({
  countryId: z.string().nullable(),
  departmentId: z.string().nullable(),
});

export type IdeaWorkplace = z.infer<typeof IdeaWorkplaceSchema>;

const EMPTY: IdeaWorkplace = { countryId: null, departmentId: null };

export function readWorkplace(): IdeaWorkplace {
  if (typeof window === 'undefined') return EMPTY;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return EMPTY;
    const parsed = IdeaWorkplaceSchema.safeParse(JSON.parse(raw));
    return parsed.success ? parsed.data : EMPTY;
  } catch {
    return EMPTY;
  }
}

/** Merges the change into what's stored, so picking one field keeps the other. */
export function writeWorkplace(change: Partial<IdeaWorkplace>): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...readWorkplace(), ...change }));
  } catch {
    // Quota or privacy mode — the user just picks again next time.
  }
}
